import React from 'react'
import DocumentTitle from 'react-document-title'
import { useQueryParams, StringParam } from 'use-query-params'
import { getStopsFromVerifyShipmentResponse } from 'apps/booking/utils/getStopsFromVerifyShipmentResponse'
import { UseVerifyShipmentProps, useVerifyShipment } from 'apps/marketplace/apiTypes/shipments'
import { generatePageTitle } from 'utils/generateAppDefaults'
import { VerifyShipmentDisplay } from './VerifyShipmentDisplay'

const VerifyPage = () => {
  const [{ id: encodedShipmentId }] = useQueryParams({ id: StringParam })
  const verifyShipmentRequest: UseVerifyShipmentProps = {
    queryParams: {
      encodedShipmentId: encodedShipmentId ?? '',
    },
  }
  const { data: verificationResponse, error: verificationError } = useVerifyShipment(
    verifyShipmentRequest
  )

  const { shipment } = verificationResponse || {}
  const { id: decodedLoadId } = shipment || {}
  const loadIdText = decodedLoadId ? `LOAD #TFX-${decodedLoadId}` : ''
  const stops = getStopsFromVerifyShipmentResponse(verificationResponse)

  return (
    <DocumentTitle title={generatePageTitle('Verify Load')}>
      <VerifyShipmentDisplay
        stops={stops}
        loadIdText={loadIdText}
        verificationError={!!verificationError}
      />
    </DocumentTitle>
  )
}

export default VerifyPage
